import {
  GET_GROUP_PERFORMANCE,
  GET_GROUP_PERFORMANCE_START,
  GET_GROUP_PERFORMANCE_SUCCESS,
  GET_GROUP_PERFORMANCE_FAIL,
  GROUP_PERFORMANCE_RESET_GROUP_DATA,
} from 'actions/groupPerformance';

import { getListPageSuccessNewData } from '../utils';

export const defaultState = {
  error: false,
  groups: {},
  loading: true,
  newlyCreated: false,
};

export default function groupPerformance(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_GROUP_PERFORMANCE:
    case GET_GROUP_PERFORMANCE_START: {
      return {
        ...state,
        error: false,
        loading: true,
      };
    }
    case GET_GROUP_PERFORMANCE_SUCCESS: {
      return {
        ...state,
        error: false,
        loading: !!payload.status,
        groups: payload.status
          ? { ...state.groups }
          : {
              ...payload,
              data: getListPageSuccessNewData(
                state.groups,
                payload.data,
                payload.links,
              ),
            },
      };
    }
    case GET_GROUP_PERFORMANCE_FAIL: {
      return {
        ...state,
        groups: [],
        error: payload.json,
        loading: false,
      };
    }
    case GROUP_PERFORMANCE_RESET_GROUP_DATA: {
      return {
        ...state,
        groups: {},
        loading: true,
      };
    }
    default:
      return state;
  }
}
